export default {
  BEACON: {
    BEACON: "Senarai Beacon",
    BEACON1: "Nama Beacon",
    BEACON2: "Masukkan Nama Beacon",
    HEADER: "Daftar Beacon",
  },
};
